import React, { useEffect, useState, useContext } from 'react';
import { useHistory, NavLink } from 'react-router-dom';

import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';
import Acess from '../../constants/Acess';
import logo from './LogoFitInsurBranco1.png';
import Icon from '../Icon';
import { Container, Logo, Title, List, Item, Settings, SubTitle, Content, ElipseIcon } from './styles';

export default function Menu(props) {
  const setShowProfile = props.showProfile; 
  const [showDashboard, setShowDashboard] = useState(false);
  const [showEnquires, setShowEnquires] = useState(false);
  const [showPolicies, setShowPolicies] = useState(false);
  const [showClaims, setShowClaims] = useState(false);
  const [showPayments, setShowPayments] = useState(false);
  const [showRenewals, setShowRenewals] = useState(false);
  const [showCommissions, setShowCommissions] = useState(false);
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();

  const goToHomePage = () => {
    history.push('home');
  }

  function requestAccess(dsDomPrivilege, idDomain, idPersonRelation, idOperation, menu) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAccess(dsDomPrivilege, idDomain, idPersonRelation, idOperation)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.ret_code == "200") {
          menu(true);
          return;
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    requestAccess("READ", Acess.MENU_DASHBOARD, null, null, setShowDashboard);
    requestAccess("READ", Acess.MENU_ENQUIRES, null, null, setShowEnquires);
    requestAccess("READ", Acess.MENU_POLICIES, null, null, setShowPolicies);
    requestAccess("READ", Acess.MENU_PAYMENTS, null, null, setShowPayments);
    requestAccess("READ", Acess.MENU_RENEWALS, null, null, setShowRenewals);
    // ToDo verificar IDDOMAIN COMISSIONS requestAccess("READ", Acess.MENU_, null, null, setShowCommissions);
  }, []);

  return (
    <Container>
      <Content>
        <Logo src={logo} onClick={() => goToHomePage()} style={{ marginLeft: '20px' }}></Logo>
        <br></br>
        <br></br>
        <Title>Menu</Title>
        <List>
          {showDashboard ? <NavLink to="/home" activeClassName='active' exact={true}><Item style={{marginTop: '10px'}}><ElipseIcon name="dashboard" />Painel</Item></NavLink> : ''}
          {showEnquires ? <NavLink to="/quotes" activeClassName='active'><Item style={{marginTop: '10px'}}><ElipseIcon name="enquiries" />Cotações</Item></NavLink> : ''}
          {showPolicies ? <NavLink to="/policies" activeClassName='active' exact={true}><Item style={{marginTop: '10px'}}><ElipseIcon name="policies" />Apolices e Endossos</Item></NavLink> : ''}
          {showClaims ? <NavLink to="/home" activeClassName='active' exact={true}><Item style={{marginTop: '10px'}}><ElipseIcon name="claimTransp" />Sinistros</Item></NavLink> : ''}
          {showCommissions ? <NavLink to="/home" activeClassName='active' exact={true}><Item style={{marginTop: '10px'}}><ElipseIcon name="commissions" />Comissões</Item></NavLink> : ''}
          {showPayments ? <NavLink to="/home" activeClassName='active' exact={true}><Item style={{marginTop: '10px'}}><ElipseIcon name="paymentTransp" />Pagamentos</Item></NavLink> : ''}
          {showRenewals ? <NavLink to="/home" activeClassName='active' exact={true}><Item style={{marginTop: '10px'}}><ElipseIcon name="renewalTransp" />Renovações</Item></NavLink> : ''}
        </List>
      </Content>
      <Settings>
        <List>
          <SubTitle>Configurações</SubTitle>
          <Item onClick={() => { setShowProfile(true) }}><Icon name="user" />Minha Conta</Item>
          <Item><Icon name="mailCinza" />Suporte</Item>
          <NavLink to="/login"><Item><Icon name="logout" />Sair</Item></NavLink>
        </List>
      </Settings>
    </Container>
  );
}
